import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CircleMessage = _resolveComponent("CircleMessage")!

  return (_openBlock(), _createBlock(_component_CircleMessage, { icon: "CROSS" }, {
    default: _withCtx(() => [
      _createElementVNode("h3", null, _toDisplayString(_ctx.translate('OOPS')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.translate('ERROR.UNKNOWN')), 1)
    ]),
    _: 1
  }))
}